import { FC } from 'react';
import { Typography, Button, useTheme } from '@mui/material';

const ActionScanButton: FC<
  React.PropsWithChildren<ActionScanButtonProps>
> = props => {
  const { onClick, value } = props;
  const theme = useTheme();
  return (
    <Button variant='text' sx={{ textTransform: 'none' }} onClick={onClick}>
      <Typography
        variant='body1'
        noWrap
        color={theme.palette.progress.textColor}>
        {value}
      </Typography>
    </Button>
  );
};

export interface ActionScanButtonProps {
  value: string;
  onClick: () => void;
}

export default ActionScanButton;
